import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';

const AccountsReportsTab = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [rows, setRows] = useState(10);
  const navigate = useNavigate();

  const rowsPerPageOptions = [10, 20, 50, 100];

  // Dummy static data for preview
  const accounts = [
    {
      id: '1',
      CustomerInfo: { fullName: 'John Doe' },
      meterNumber: 'WM-10001',
      UnitInfo: { name: 'Unit A' },
      accountNumber: 'AC-001',
      userType: 'prepaid',
      accountBalance: 500.75,
      negativeBalance: 0.0,
      currentReading: 123,
      status: 'active',
      balanceLoaded: true
    },
    {
      id: '2',
      CustomerInfo: { fullName: 'Jane Smith' },
      meterNumber: 'WM-10002',
      UnitInfo: { name: 'Unit B' },
      accountNumber: 'AC-002',
      userType: 'postpaid',
      accountBalance: 0,
      negativeBalance: 150.5,
      currentReading: 456,
      status: 'inactive',
      balanceLoaded: true
    }
  ];

  const filteredAccounts = accounts.filter((account) =>
    Object.values(account).some((val) =>
      val?.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const handleView = (rowData) => {
    navigate(`/view_account/${rowData.id}`, { state: { account: rowData } });
  };

  const actionBodyTemplate = (rowData) => (
    <div className="flex gap-2">
      <Button
        icon="ti ti-eye"
        className="p-button-rounded p-button-text"
        onClick={() => handleView(rowData)}
        tooltip="View"
      />
    </div>
  );

  const statusBodyTemplate = (rowData) => {
    const statusColors = {
      active: 'success',
      inactive: 'danger'
    };
    const status = rowData.status?.toLowerCase() || 'n/a';
    const color = statusColors[status] || 'secondary';

    return (
      <span className={`badge rounded-pill text-bg-${color}`}>
        {status.charAt(0).toUpperCase() + status.slice(1)}
      </span>
    );
  };

  const paymentTypeTemplate = (rowData) => {
    const typeColors = {
      postpaid: 'warning',
      prepaid: 'success'
    };
    const userType = rowData.userType?.toLowerCase() || 'n/a';
    const color = typeColors[userType] || 'secondary';

    return (
      <span className={`badge rounded-pill text-bg-${color}`}>
        {userType.charAt(0).toUpperCase() + userType.slice(1)}
      </span>
    );
  };

  const currencyTemplate = (value) => {
    return value
      ? new Intl.NumberFormat('en-KE', {
          style: 'currency',
          currency: 'KES'
        }).format(value)
      : 'KES 0.00';
  };

  const accountBalanceTemplate = (rowData) => {
    return currencyTemplate(rowData.accountBalance);
  };

  const negativeBalanceTemplate = (rowData) => {
    return currencyTemplate(rowData.negativeBalance);
  };

  return (
    <div className="card">
      <div className="card-body">
        <div className="row mb-3">
          <div className="col-md-3 col-xs-12">
            <input
              type="text"
              className="form-control"
              placeholder="Search accounts..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        <div className="dt-responsive table-responsive">
          <DataTable
            value={filteredAccounts}
            emptyMessage="No accounts found."
            sortMode="multiple"
            paginator
            rows={rows}
            rowsPerPageOptions={rowsPerPageOptions}
            stripedRows
            tableStyle={{ minWidth: '50rem' }}
          >
            <Column
              field="fullname"
              header="Customer"
              sortable
              body={(rowData) =>
                rowData.CustomerInfo ? rowData.CustomerInfo.fullName : 'N/A'
              }
            />
            <Column field="meterNumber" header="Meter S/N" sortable />
            <Column
              field="UnitInfo"
              header="Unit"
              sortable
              body={(rowData) => rowData.UnitInfo?.name || 'N/A'}
            />
            <Column field="accountNumber" header="Account No" sortable />
            <Column
              field="userType"
              header="Payment Type"
              sortable
              body={paymentTypeTemplate}
            />
            <Column
              field="accountBalance"
              header="Account Bal"
              sortable
              body={accountBalanceTemplate}
            />
            <Column
              field="negativeBalance"
              header="Negative Bal"
              sortable
              body={negativeBalanceTemplate}
            />
            <Column field="status" header="Status" body={statusBodyTemplate} sortable />
            <Column header="Actions" body={actionBodyTemplate} />
          </DataTable>
        </div>
      </div>
    </div>
  );
};

export default AccountsReportsTab;
